import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGetOne, useRecordContext } from "react-admin";
import { statusText } from "../../../components/Label";

// The entity's operations by status, as one row of figures.
function RecentActivity() {
  const { t }: { t: any } = useTranslation();
  const { data } = useGetOne("statsByProject", { id: useRecordContext()?.id });
  const figures = Object.entries(data?.data ?? {}).filter(([key]) => key !== "id");
  if (!figures.length) return null;
  return (
    <Box display="flex" flexWrap="wrap" columnGap={5} rowGap={2} sx={{ py: 3, borderBottom: 1, borderColor: "divider" }}>
      {figures.map(([key, value]) => (
        <Box key={key}>
          <Typography component="div" sx={{ fontSize: 28, fontWeight: 600, lineHeight: 1.2, fontVariantNumeric: "tabular-nums" }}>
            {String(value)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t(statusText(key.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2")))}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default RecentActivity;
